<script>
    import { Doughnut } from 'vue-chartjs'

    export default {
        name: 'DoughnutChart',
        extends: Doughnut,
        props: {
            chartData: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                default: null
            },
            // false: a static ring, without hover effect or tooltip
            interactive: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 70,
                    legend: {
                        display: false
                    },
                    ...(this.interactive ? {} : { events: [], hover: { mode: null } }),
                    tooltips: {
                        enabled: this.interactive,
                        backgroundColor: '#ffffff',
                        titleFontColor: '#111827',
                        bodyFontColor: '#111827',
                        borderColor: '#d1d5db',
                        borderWidth: 1,
                        callbacks: {
                            label: (tooltipItem, data) => {
                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                return `${this.type}: ${value}`
                            }
                        }
                    }
                }
            }
        },
        watch: {
            chartData: {
                handler(newData) {
                    this.renderChart(newData, this.options)
                }
            }
        },
        mounted() {
            this.renderChart(this.chartData, this.options)
        },
        render(createElement) {
            return createElement('canvas', { ref: 'canvas' })
        }
    }
</script>
